import { useSearchParams } from 'next/navigation'
import { isNil } from 'ramda'

import {
  UseClickNotificationReturnType,
  Notification,
} from '~/src/components/shared/Notification/types'

import { Urls } from '~/constants/urls'

import { TabName } from '~/src/components/Operational/LoadBoardDashboard/DetailView/types'

const useClickNotification = (): UseClickNotificationReturnType => {
  const searchParams = useSearchParams()

  const createQueryString = (options: {
    legIdx?: number | null
    stopIdx?: number | null
    freightRecordId?: number | null
  }) => {
    const params = new URLSearchParams(searchParams)
    if (!isNil(options.legIdx)) params.set('leg', options.legIdx.toString())
    if (!isNil(options.stopIdx)) params.set('stop', options.stopIdx.toString())
    if (!isNil(options.freightRecordId)) {
      params.set('tab', TabName.Freight)
      params.set('freightrecord', options.freightRecordId.toString())
    }

    return params.toString()
  }

  const createHref = (notification: Notification) => {
    const { legIdx, stopIdx, loadId, freightRecordId } = notification

    if (!loadId) return ''

    return `${Urls.operatorLoad({ id: loadId })}?${createQueryString({
      legIdx,
      stopIdx,
      freightRecordId,
    })}`
  }

  return [createHref]
}

export default useClickNotification
